// removed by extract-text-webpack-plugin
module.exports = {"root":"_1liHN1HsbOh21tYoJ6TKCQ","projects":"_1TfW8RHRx2HO0Z8qFQmsnu","list-wrapper":"_37iE8kNlV2B38vqOaQ8Xeh","current-project":"_2pPjIlZ6fLUEQEgJ6Yhpwm","list":"_3GCYEKAhIfasQpaVuV4HvZ","separator":"_3FRf7YV0FpgF4tBo1ndnrN","create-project":"_1rV1gdbViPSvuinwMfWHcn","action":"YUQo67vAQzMs9cyv-zQpq"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/show/show.scss
// module id = 1622
// module chunks = 0